/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { environment } from "../../../environment";
import { fixedT, translationKeys } from "../../../Internationalisierung/i18nBasis";
import "./ErrorView.scss";

export default function ErrorView() {
    return (
        <div className="lan-errorview">
            <div className="lan-errorview__container">
                <div className="lan-errorview__content">
                    <h1 className="lan-errorview__title">
                        {fixedT(translationKeys.errorView.title)}
                    </h1>
                    <p className="lan-errorview__subtitle">
                        {fixedT(translationKeys.errorView.subtitle)}
                    </p>
                </div>
                <div className="lan-errorview__actions">
                    <a
                        className="lan-errorview__button"
                        href={`/${environment.mandant}/`}
                    >
                        {fixedT(translationKeys.errorView.action)}
                    </a>
                </div>
            </div>
        </div>
    )
}